<template>
  <div id="app">
    <!-- header start -->
    <div
      class="header-big"
      v-if="data.headerShow"
      :style="{
        display: state.dropdownVisible ? 'block' : 'none',
        opacity: state.dropdownVisible ? 1 : 0,
      }"
    >
      <div class="header-content">
        <div class="header-area">
          <div class="header-area-logo-nav">
            <div class="header-area-logo">
              <a href="https://www.shitongol.com/">
                <img :src="imgLogo" alt="世通在线LOGO" />
              </a>
            </div>
            <div class="header-area-nav">
              <ul>
                <li v-for="(item, index) in data.headerNavArr" :key="index">
                  <a
                    @click="headerNavClick(item.path, index)"
                    :class="{
                      'header-active-css':
                        item.path === initialPath ||
                        (isRouter && item.path === '/cooperative'),
                    }"
                    >{{ item.text }}</a
                  >
                </li>
                <li>
                  <el-dropdown @command="handleCommandDownload">
                    <a style="outline: none">下载</a>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item command="download_st"
                          >世通在线客户端 <span>下载</span></el-dropdown-item
                        >
                        <el-dropdown-item command="ai_identification"
                          >世通在线AI报价助手
                          <span class="ai-draw">下载</span></el-dropdown-item
                        >
                        <el-dropdown-item command="download_dotNetFx40_file"
                          >系统运行环境
                          <span class="environment-draw"
                            >下载</span
                          ></el-dropdown-item
                        >
                        <el-dropdown-item command="download_newHand_file"
                          >小白指引文件
                          <span class="linBai-draw"
                            >下载</span
                          ></el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </li>
              </ul>
            </div>
          </div>
          <div class="header-area-login">
            <!-- <div @click="loginClick" v-if="data.noLoginShow" class="noLoginCss">
							<a>登录/注册</a>
						</div> -->
            <el-tooltip
              effect="dark"
              content="点击展开功能菜单"
              placement="left"
              :enterable="false"
            >
              <div
                class="isLoginCss"
                v-if="data.isLoginShow"
                @click="openDrawerClick"
              >
                <div>
                  <img
                    src="./assets/images/common/headerPicture.png"
                    alt="用户头像"
                  />
                </div>
                <div>
                  <a>{{ data.userArr.fCustomerName }}</a>
                </div>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <!-- header end -->

    <router-view v-if="data.isRouterAlive"></router-view>

    <!-- float start -->
    <div class="float-big" :class="{ show: true }">
      <div class="float-content">
        <div class="float-area">
          <a
            href="https://work.weixin.qq.com/kfid/kfc8fc50819da496bf2"
            target="_blank"
          >
            <img src="./assets/images/common/kf@2x.png" alt="客服图标" />
            <p>在线客服</p>
          </a>
          <div
            class="float-list"
            :style="{ height: showFloatBig ? '240px' : '170px' }"
          >
            <p>
              <i>联系电话：13532667828</i>
              <span></span>
              <a>
                <img src="./assets/images/common/icon-tel.png" alt="电话咨询" />
                <div class="float-list-name">电话咨询</div>
              </a>
            </p>
            <p>
              <i>扫一扫添加微信</i>
              <span></span>
              <a>
                <img src="./assets/images/common/wechat.png" alt="微信咨询" />
                <div class="float-list-name">微信咨询</div>
              </a>
            </p>
            <p class="float-top" v-show="showFloatBig">
              <a @click="scrollToTopSmooth">
                <img src="./assets/images/common/icon-xs.png" alt="回到顶部" />
                <div class="float-list-name">回到顶部</div>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- float end -->

    <!-- back top start -->
    <!-- <el-backtop :right="50" :bottom="400" /> -->
    <!-- back top end -->

    <!-- drawer start -->
    <el-drawer
      v-model="data.drawerShow"
      title="我的功能菜单"
      class="drawer-big"
    >
      <div
        class="drawer_nav_area"
        v-for="(item, index) in data.navBigArr"
        :key="index"
      >
        <p class="drawer_nav_title">{{ item.title }}</p>
        <div class="drawer_nav_list">
          <div
            v-for="(item_, index_) in item.list"
            :key="index_"
            @click="drawerNavClick(item_.text)"
          >
            <img :src="item_.src" :alt="item_.text" />
            <p>{{ item_.text }}</p>
          </div>
        </div>
      </div>
    </el-drawer>
    <!-- drawer end -->

    <!-- dialog start -->
    <el-dialog
      v-model="data.userChangeDialog"
      title="切换账号"
      width="30%"
      class="dialog-big"
      :close-on-click-modal="false"
    >
      <el-select
        v-model="data.userChangeSelect"
        placeholder="请选择要切换的账号"
        size="large"
      >
        <el-option
          v-for="(item, index) in data.userChangeOption"
          :key="index"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <div class="dialog-btn">
        <div>
          <el-button color="#009BFF" plain @click="qxUserChangeSelect"
            >取消</el-button
          >
        </div>
        <div>
          <el-button color="#009BFF" @click="qdUserChangeSelect"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- dialog end -->

    <!-- footer start -->
    <div class="footer-big" v-if="data.footerShow">
      <div class="footer-content">
        <div class="footer-area">
          <p>
            <span>Copyright&nbsp;©&nbsp;</span>
            <span>2022&nbsp;</span>
            <span>-</span>
            <span>&nbsp;2023&nbsp;</span>
            <span>世通在线&nbsp;</span>
            <span>
              <a href="https://www.shitongol.com/" target="_blank"
                >shitongol.com&nbsp;</a
              >
            </span>
            <span>All&nbsp;Rights&nbsp;Reserved.&nbsp;</span>
            <span>备案号：</span>
            <span>
              <img src="./assets/images/common/gongan.png" alt="公安" />
              <a
                href="https://beian.miit.gov.cn/#/Integrated/index"
                target="_blank"
                >粤ICP备2023007946号</a
              >
            </span>
          </p>
        </div>
      </div>
    </div>
    <!-- footer end -->
  </div>
</template>


<script>
import {
  ref,
  reactive,
  nextTick,
  provide,
  watch,
  computed,
  onMounted,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessageBox, ElMessage } from "element-plus";
import storage from "@/utils/storage";
import { useStore } from "vuex";
export default {
  name: "app",
  setup() {
    // 实例化路由
    const router = useRouter();
    const route = useRoute(); // 当前页面路
    const store = useStore();
    const initialPath = computed(() => route.path); // 初始路由
    // 定义初始值
    const imgLogo = ref("");
    const showFloatBig = ref(false); // 控制显示隐藏的状态
    const isRouter = ref(false);
    const newRouter = reactive([
      "detailspress",
      "detailspress2",
      "detailspress3",
      "detailspress4",
    ]);
    const data = reactive({
      // 刷新路由用的初始值
      isRouterAlive: true,
      // 头部导航初始值
      headerNavArr: [
        {
          text: "首页",
          path: "/",
        },
        {
          text: "产品",
          path: "/products",
        },
        {
          text: "关于世通",
          path: "/aboutUs",
        },
        {
          text: "新闻动态",
          path: "/cooperative",
        },
        {
          text: "联系我们",
          path: "/contactUs",
        },
      ],
      // 抽屉初始值
      drawerShow: false,
      // 抽屉导航数组初始值
      navBigArr: [
        {
          title: "常用功能",
          list: [
            {
              src: require("./assets/images/common/nav/order.png"),
              text: "生产进度",
            },
            {
              src: require("./assets/images/common/nav/enquiry.png"),
              text: "询价",
            },
            {
              src: require("./assets/images/common/nav/contact.png"),
              text: "联系客服",
            },
          ],
        },
        {
          title: "其他功能",
          list: [
            {
              src: require("./assets/images/common/nav/userDetail.png"),
              text: "信息中心",
            },
            {
              src: require("./assets/images/common/nav/share.png"),
              text: "分享",
            },
          ],
        },
        {
          title: "设置",
          list: [
            {
              src: require("./assets/images/common/nav/changeUser.png"),
              text: "切换账号",
            },
            {
              src: require("./assets/images/common/nav/logout.png"),
              text: "退出登录",
            },
          ],
        },
      ],
      // 抽屉中的切换账号板块初始值
      userChangeDialog: false,
      userChangeSelect: "",
      userChangeOption: [],
      // 头部和脚部公共导航栏初始值
      headerShow: true,
      footerShow: true,
      // 用户信息和登录状态初始值
      userArr: [],
      isLoginShow: false,
      noLoginShow: true,
    });
    const state = reactive({
      dropdownVisible: true, // 初始状态为隐藏
      showBackToTop: false,
    });
    // 路由刷新的方法
    const reload = () => {
      data.isRouterAlive = false;
      nextTick(() => {
        data.isRouterAlive = true;
      });
    };

    // 点击头部导航栏的时候
    const headerNavClick = (e) => {
      router.push({ path: e });
    };

    // 点击下载的时候
    const handleCommandDownload = (e) => {
      // console.log(e)
      let v = e;
      if (v == "download_st") {
        router.push({ path: "/downloadFile" });
      } else if (v == "download_dotNetFx40_file") {
        let src_ = "https://oss.shitongol.com/dotNetFx40_Full_setup.exe";
        location.href = src_;
        // window.open(src_)
      } else if (v == "download_newHand_file") {
        // let src_ = 'https://oss.shitongol.com/%E5%B0%8F%E7%99%BD%E6%8C%87%E5%BC%95.pptx'
        let src_ =
          "https://view.officeapps.live.com/op/view.aspx?src=https%3A%2F%2Foss.shitongol.com%2F%25E5%25B0%258F%25E7%2599%25BD%25E6%258C%2587%25E5%25BC%2595.pptx&wdOrigin=BROWSELINK";
        window.open(src_);
      } else if (v == "ai_identification") {
        let src_ =
          "https://appletsfiles.oss-cn-shenzhen.aliyuncs.com/DownloadFile/version/P013/AI%E6%8A%A5%E4%BB%B7%E5%8A%A9%E6%89%8B%E6%89%93%E5%8C%85.rar";
        window.open(src_);
      }
    };

    // 点击登录的时候
    const loginClick = () => {
      router.push({ path: "/login" });
    };

    // 点击登录后的用户信息板块的时候(打开抽屉)
    const openDrawerClick = () => {
      data.drawerShow = true;
    };

    // 点击抽屉中的导航按钮的时候
    const drawerNavClick = (e) => {
      let text_ = e;
      if (text_ == "生产进度") {
        ElMessage({
          message: "该功能即将开放",
          type: "warning",
          offset: 250,
        });
      } else if (text_ == "询价") {
        ElMessage({
          message: "该功能即将开放",
          type: "warning",
          offset: 250,
        });
      } else if (text_ == "联系客服") {
        let src_ = "https://work.weixin.qq.com/kfid/kfc8fc50819da496bf2";
        window.open(src_);
      } else if (text_ == "信息中心") {
        // 点击的是信息中心的时候
        router.push({ path: "/userDetail" });
        // 关闭抽屉
        data.drawerShow = false;
      } else if (text_ == "分享") {
        ElMessage({
          message: "该功能即将开放",
          type: "warning",
          offset: 250,
        });
      } else if (text_ == "切换账号") {
        // 点击的是切换账号的时候
        data.userChangeOption = [];
        // 获取当前用户缓存
        let userAll = storage.getItem("user_storage");
        // 循环遍历赋值给切换账号的弹窗选项中
        userAll.map((e) => {
          // console.log(e)
          data.userChangeOption.push({ label: e.fCustomerName, value: e.fID });
        });
        // 然后设置默认选中(当前的登录账号)
        let userDefalue = storage.getItem("user_default_account");
        data.userChangeSelect = userDefalue.fID;
        data.userChangeDialog = true;
      } else if (text_ == "退出登录") {
        // 点击的是退出登录的时候
        ElMessageBox.confirm("您是否确定退出账号？", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            store.commit("setUsetInfo", {});
            storage.removeItem("user_storage");
            storage.removeItem("user_default_account");
            data.userArr = [];
            data.isLoginShow = false;
            data.noLoginShow = true;
            // 关闭抽屉
            data.drawerShow = false;
            router.replace({ path: "/" });
            ElMessage({
              message: "已退出账号",
              type: "success",
              offset: 300,
            });
          })
          .catch(() => {
            // console.log('取消了')
          });
      }
    };

    // 点击切换账号弹窗中的取消按钮的时候
    const qxUserChangeSelect = () => {
      data.userChangeDialog = false;
    };

    // 点击切换账号弹窗中的确定按钮的时候
    const qdUserChangeSelect = () => {
      // 获取当前用户缓存
      let userAll = storage.getItem("user_storage");
      // 循环遍历(通过遍历查询当前被选中的账号跟被循环到的是否匹配)
      userAll.map((e) => {
        if (data.userChangeSelect == e.fID) {
          // 如果匹配的话,把匹配到的数据重新赋值给缓存user_default_account
          storage.setItem("user_default_account", e);
          // 给当前用户信息初始值赋值
          data.userArr = e;
          // 关闭抽屉
          data.drawerShow = false;
          reload();
          ElMessage({
            message: "已切换账号到" + "【" + e.fCustomerName + "】",
            type: "success",
            offset: 300,
          });
          // 关闭弹窗
          data.userChangeDialog = false;
        }
      });
    };

    // 监听路由变化
    watch(
      () => router.currentRoute.value.path,
      (toPath) => {
        const trimmedStr = toPath.replace(/^\//, "");
        // 检查数组中是否有与 trimmedStr 相匹配的元素
        for (let key in newRouter) {
          if (newRouter.hasOwnProperty(key)) {
            if (trimmedStr === newRouter[key]) {
              isRouter.value = true;
              break;
            } else {
              isRouter.value = false;
            }
          }
        }
        // 当点击产品时自动滚动
        if (toPath === "/products") { 
          window.scrollTo({
            top: 600, // 从页面顶部向下滚动 500 像素
            behavior: "smooth", // 平滑滚动
          });
        }
        // 固定头部
        if (toPath == "/cooperative") {
          state.dropdownVisible = true;
        }
        // 判断路由中是否存在 Evaluation 值
        // 如果有的话存入缓存
        let queryV = router.currentRoute.value.query.Evaluation;

        if (queryV != undefined) {
          // 存入缓存
          sessionStorage.setItem("user_evaluation", queryV);
        }

        // 如果监听到当前路由是以下路由的话,隐藏页头和页脚
        if (toPath == "/login" || toPath == "/register") {
          data.headerShow = false;
          data.footerShow = false;
        } else {
          // 获取用户缓存(用于判断用户是否登录)
          const userinfo = storage.getItem("user_default_account") || {};
          if (userinfo && userinfo.fID) {
            // console.log('登录了')
            data.userArr = userinfo;
            data.noLoginShow = false;
            data.isLoginShow = true;
          } else {
            // console.log('没登录')
            data.userArr = [];
            data.isLoginShow = false;
            data.noLoginShow = true;
          }
          data.headerShow = true;
          data.footerShow = true;
        }

        if (toPath !== "/products") {
          scrollToTop();
        }
      },
      // { immediate: true, deep: true } 这里之前是立即执行
      { immediate: false, deep: true }
    );
    // 在组件挂载后执行的操作
    onMounted(() => {
      if (router.currentRoute._value.path !== "/products") {
        scrollToTop();
      }
      imgLogo.value = require("@/assets/images/logo/logo-l@2x.png");
      // 监听滚动事件或其他适当事件
      window.addEventListener("scroll", () => {
        // 根据条件修改显示状态
        state.dropdownVisible = true; // 或者根据具体条件设置显示状态
        state.showBackToTop = window.scrollY > 100;
        // 获取滚动条滚动的高度
        let scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        // 设置阈值，当滚动高度超过某个值时显示 float-big 元素
        showFloatBig.value = scrollTop > 300;
      });
    });
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "auto", // 不要平滑
      });
    };
    // 回到顶部
    const scrollToTopSmooth = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 不要平滑
      });
    };
    provide("reload", reload);
    return {
      imgLogo,
      reload,
      data,
      initialPath,
      headerNavClick,
      handleCommandDownload,
      loginClick,
      openDrawerClick,
      drawerNavClick,
      qxUserChangeSelect,
      qdUserChangeSelect,
      state,
      scrollToTop,
      scrollToTopSmooth,
      showFloatBig,
      isRouter,
    };
  },
};
</script>


<style>
/* 引入app.css */
@import url("assets/css/app.css");
</style>
